import { CanvasOverlayViewer } from '@leverege/ui-image-overlay';
import { jsx as _jsx } from "react/jsx-runtime";
export default function OverlayedImage(props) {
  const {
    layers,
    src,
    overlaysEnabled,
    context
  } = props;
  return /*#__PURE__*/_jsx(CanvasOverlayViewer, {
    layersEnabled: overlaysEnabled,
    imageUrl: src,
    layers: layers,
    context: context
  });
}